// extracted by mini-css-extract-plugin
export default {"image":"HomecareRequest_image__bXjW8"};